import { render, staticRenderFns } from "./ImportApiSettings.vue?vue&type=template&id=5490efdd"
import script from "./ImportApiSettings.vue?vue&type=script&lang=js"
export * from "./ImportApiSettings.vue?vue&type=script&lang=js"
import style0 from "./ImportApiSettings.vue?vue&type=style&index=0&id=5490efdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports